import { message } from "antd";
import { mixGetV1, mixPostV1 } from "services/mixin";
import { homeUrl } from "./routeConfig";
import { API_URL, API_USER_URL } from "env";

const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

async function loginUser(email: string, password: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        });
        const data = await res.json();
        if (res.status) {
            localStorage.setItem('token', data.data.access_token);
            localStorage.setItem('user', JSON.stringify(data.data.info));
            // localStorage.setItem('user', JSON.stringify(res.data.info));
            const res2 = await fetch(API_USER_URL + `/api/v1/be/users/${data.data.info.id}` ,{
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.data.access_token}`,
                },
            })
            // const res2 = await getUserInfo(data.data.info.id);
            const res2Data = await res2.json();

            if (res2Data.status) {
                localStorage.setItem('user', JSON.stringify(res2Data.data))

                message.success('Login successful!');
                window.location.href = homeUrl; // Redirect to home page
            }

            // message.success('Login successful!');
            window.location.href = homeUrl; // Redirect to accounts overview page
            return;
        }
        else if (data.status === false && data.error && data.error.needs_verification) {
            message.info('Your account needs verification. Sending verification code to your email.');
            const resOtp = await fetch(API_USER_URL + '/api/v1/be/request-verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                }),
            });
            const resOtpData = await resOtp.json();
            if (resOtpData.status) {
                message.success('Verification code sent to your email. Please check your inbox.');
            } else {
                message.error(resOtpData.message || 'Failed to send verification code, please try again!');
                return;
            }
            window.location.href = `/verify-otp?uid=${data.error.user_id}&reactive=true`;

        } else if (data.status === false && data.error && data.error.password_wrong) {
            message.error('Incorrect password, please try again!');
            return;
        }
        else {
            message.error('Login failed, please try again!');
            return;
        }
    }
    catch (error) {
        console.error('Login error:', error);
        message.error('Login failed, please try again!' + JSON.stringify(error));
    }
}

async function signUpUser(email: string, password: string, confirmPassword: string, reffralCode?: string): Promise<any> {
    try {
        const send_data = {
            email: email,
            password: password,
            password_confirmation: confirmPassword,
        }
        const res = await fetch(API_USER_URL + '/api/v1/be/sign-up', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                reffralCode ? { ...send_data, referral_code: reffralCode } : send_data
            ),
        });
        const resData = await res.json();

        if (res.status) {
            localStorage.setItem('token', resData.data.token);
            message.success('Registration successful! Please check your email to verify your account');
            return resData.data.user;
        } else {
            message.error(resData.message || 'Registration failed, please try again!');
            return;
        }
    } catch (error) {
        console.error('Registration error:', error);
        message.error('Registration failed, please try again!' + JSON.stringify(error));
    }

}

async function getUserInfo(userId: string) {
    try {
        const res = await fetch(API_USER_URL + `/api/v1/be/users/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
        });
        const data = await res.json();

        if (data.status) {
            return data.data;
        } else {
            message.error(data.message || 'Failed to fetch user info, please try again!');
            return null;
        }
    } catch (error) {
        console.error('Fetch user info error:', error);
        message.error('Failed to fetch user info, please try again!' + JSON.stringify(error));
        return null;
    }
}


async function updateUserInfo(userId: string, fullName: string, dob: string) {
    try {
        const res = await fetch(API_USER_URL + `/api/v1/be/users/${userId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                fullname: fullName,
                birthday: formatDate(dob),
            }),
        });
        const data = await res.json();

        if (data.status) {
            message.success('Profile updated successfully!');
            return true;
        } else {
            message.error(data.message || 'Profile update failed, please try again!');
            return false;
        }
    } catch (error) {
        console.error('Profile update error:', error);
        message.error('Profile update failed, please try again!' + JSON.stringify(error));
        return false;
    }
}

async function submitResetPasswordEmail(email: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/forget-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("Password reset email sent. Please check your email.");
            return true;
        }
        else {
            message.error("Error resetting password. Please try again. Error:" + data.message);
            return false;
        }
    }
    catch (error) {
        message.error("Error resetting password. Please try again. Error:" + error);
        return false;
    }
}

async function submitResendOTP(email: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/resend-forget-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("OTP resent successfully. Please check your email.");
        }
        else {
            message.error("Error resending OTP. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error resending OTP. Please try again. Error:" + error);
    }
}

async function submitVerifyOTP(email: string, otpValue: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/verify-reset-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: email, otp: otpValue }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("OTP verified successfully. Please enter your new password.");
            return data.reset_token;
        }
        else {
            message.error("Error verifying OTP. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error verifying OTP. Please try again. Error:" + error);
    }
}

async function submitReset(email: string, resetToken: string, password: string, confirmPassword: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/reset-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                reset_token: resetToken,
                password: password,
                password_confirmation: confirmPassword
            }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("Password reset successful. Redirecting to login page in 3 seconds...");
            setTimeout(() => {
                window.location.href = '/login';
            }, 3000);
        }
        else {
            message.error("Error resetting password. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error resetting password. Please try again. Error:" + error);
    }
}

async function checkRefCodeExists(referralCode: string): Promise<boolean> {
    try {
        const res = await fetch(API_USER_URL + `/api/v1/be/referral/check-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: referralCode }),
        });
        const data = await res.json();
        if (data.status) {
            return true;
        }
        else {
            message.error("Error checking referral code. Please try again. Error:" + data.message);
            return false;
        }
    }
    catch (error) {
        message.error("Error checking referral code. Please try again. Error:" + error);
        return false;
    }
}

function checkPasswordStrength(password: string): boolean {
    // At least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
}

function checkConfirmPassword(password: string, confirmPassword: string): boolean {
    return password === confirmPassword;
}


export {
    signUpUser,
    checkPasswordStrength,
    checkConfirmPassword,
    loginUser,
    getUserInfo,
    updateUserInfo,
    checkRefCodeExists,
    submitResetPasswordEmail,
    submitResendOTP,
    submitVerifyOTP,
    submitReset,
};